/* eslint-disable */



/*
 * INTRO: New DixonsCarphoneGroup namespace to expose Public API
 * USAGE: example namespace structure namespace.platform.component
 */
if (typeof window !== 'undefined') {
  window.DCG = window.DCG || {};
}

window.DCG.$ = $;

/*
 * INTRO: This function enables creation of nested namespaces
 * USAGE: DCG.createNameSpace(DCG, 'DCG.Mobile.utils.rotate')
 * MORE: on http://addyosmani.com/blog/essential-js-namespacing/
 */
window.DCG.createNameSpace = function(ns, ns_string) {
  var parts = ns_string.split('.'),
    parent = ns,
    pl, i;
  if (parts[0] == "DCG") {
    parts = parts.slice(1);
  }
  pl = parts.length;
  for (i = 0; i < pl; i++) {
    if (typeof parent[parts[i]] == 'undefined') {
      parent[parts[i]] = {};
    }
    parent = parent[parts[i]];
  }
  return parent;
}

/*
 * INTRO: Ability to extend nested namesapce using jquery object extend
 * eg. DCG.utils.function and DCG.utils.function1
 *           ^                      ^
 * NOTE: see how DCG.extendNameSpace method will extend the previously created sub namespace with new properties
 * USAGE: DCG.extendNameSpace (true, DCG.utils, {function3: function(){console.log('func3')} } )
 * MORE: http://api.jquery.com/jquery.extend/
 */
window.DCG.extendNameSpace = $.extend;
